/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useFocusRing } from '@react-aria/focus';
import React from 'react';

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

/**
 * This is a plain HTML button that only shows outline when focused from keyboard
 * Many of our current button controls aren't keyboard navigable because we
 * completely removed outline
 */
export const PlainHtmlButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ style, ...props }, ref) => {
    const { isFocusVisible, focusProps } = useFocusRing();
    return (
      <button
        type="button"
        ref={ref}
        style={{
          ...(!isFocusVisible ? { outline: 'none' } : undefined),
          ...style,
        }}
        {...focusProps}
        {...props}
        css={css`
          u {
            text-decoration: underline;
          }
        `}
      />
    );
  },
);
